<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="oqlf_connaissance_francais" v-model="sasEquivalence.connaissanceLangueFrancaise" :live="liveSasEquivalence(6132)" />
    <CatalogueLive
      code="oqlf_3ans_detude"
      v-model="sasEquivalence.anneesDEtudesTempsPleinEnFrancais3"
      :live="liveSasEquivalence(6133)"
      :opq-if="estOui(sasEquivalence.connaissanceLangueFrancaise)"
    />
    <CatalogueLive
      code="oqlf_examens_secondaire"
      v-model="sasEquivalence.examensFrancais4EOu5EAnneeDuSecondaire"
      :live="liveSasEquivalence(6134)"
      :opq-if="estOui(sasEquivalence.connaissanceLangueFrancaise)"
    />
    <CatalogueLive
      code="oqlf_certificat_detudes"
      v-model="sasEquivalence.certificatEtudesSecondairesAuQuebec"
      :live="liveSasEquivalence(6135)"
      :opq-if="estOui(sasEquivalence.connaissanceLangueFrancaise)"
    />
    <FileInput
      code="oqlf_preuve"
      :file="sasEquivalence.preuveLangueFrancaise"
      :live="liveSasEquivalence(6137)"
      :opq-if="estOui(sasEquivalence.connaissanceLangueFrancaise)"
      @file-deleted="sasEquivalence.preuveLangueFrancaise = null"
    />
    <ophq-alert type="error" code="avertissement_langue_francaise" v-if="conditionAvertissement"></ophq-alert>
  </v-form>
</template>


<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasEquivalence() {
      return this.sas.sasEquivalence
    },
    conditionAvertissement() {
      return (
        this.estNon(this.sas.sasEquivalence.anneesDEtudesTempsPleinEnFrancais3) &&
        this.estNon(this.sas.sasEquivalence.examensFrancais4EOu5EAnneeDuSecondaire) &&
        this.estNon(this.sas.sasEquivalence.certificatEtudesSecondairesAuQuebec)
      )
    }
  },
  methods: {
    liveSasEquivalence(cle) {
      return { endpoint: "sas-equivalence", cle: cle, fileId: this.sasEquivalence.id }
    }
  }
}
</script>

<style>
</style>